export function convertToAdyenNumber(number: string) {
  return Number((Number(number.replace(",", "")) * 100).toFixed(2));
}
